import { DiscountAgreementStatusEnum } from '@/types/types';

type DiscountAgreementStatusName = keyof typeof DiscountAgreementStatusEnum;

type StatusChangeSource = {
    Id: string;
    Status: string;
    ValidTo?: string | null;
};

export const convertStatusNameToValue = (statusName: string): DiscountAgreementStatusEnum => {
    const statusValue: unknown =
        DiscountAgreementStatusEnum[statusName as DiscountAgreementStatusName];
    if (typeof statusValue !== 'number') {
        throw new Error(`Unknown discount agreement status: ${statusName}`);
    }
    return statusValue;
};

export const buildStatusChangePayload = <Agreement extends StatusChangeSource>(
    agreement: Agreement,
    nextStatus: DiscountAgreementStatusEnum
) => ({
    ...agreement,
    ValidTo: resolveValidToForUpdate(agreement),
    DiscountAgreementStatus: nextStatus,
    DiscountAgreementId: agreement.Id,
});

export const resolveValidToForUpdate = (agreement: StatusChangeSource) => {
    const isStoredAsPublished = agreement.Status === 'Published';
    return isStoredAsPublished ? undefined : agreement.ValidTo;
};
